import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../components/Logo';
import './landing.css';

// LandingShell — gemensam ram för alla landing-sidor. Sticky nav, footer.
// Vi använder en separat CSS-fil för landing eftersom Tailwind-tokenseten
// är produkt-DNA (loupe-bg etc), men landing ska kunna vara mer fri.

interface LandingShellProps {
  children: ReactNode;
  currentPage?: 'hub' | 'models' | 'photographers' | 'duos';
}

const NAV_LINKS = [
  { to: '/for-models', label: 'For models', key: 'models' },
  { to: '/for-photographers', label: 'For photographers', key: 'photographers' },
  { to: '/for-duos', label: 'For duos', key: 'duos' },
] as const;

// Vuelette är split i två domäner:
//   vuelette.com      = marketing / landing pages (denna shell)
//   app.vuelette.com  = själva produkten + /login
//
// Sign in från landing ska därför gå till app.vuelette.com/login, INTE en
// relativ /login på marketing-domänen (där den ändå inte skulle renderas
// eftersom RootGate visar Hub som default).
const SIGN_IN_URL = 'https://app.vuelette.com/login';

export function LandingShell({ children, currentPage = 'hub' }: LandingShellProps) {
  return (
    <div className="vuelette-landing">
      <div className="vl-nav-wrap">
        <nav className="vl-nav">
          <Link to="/" className="vl-brand-link" aria-label="Vuelette home">
            <Logo size="md" />
          </Link>
          <div className="vl-nav-links">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.key}
                to={l.to}
                className={`vl-nav-link ${currentPage === l.key ? 'is-active' : ''} hide-mobile`}
              >
                {l.label}
              </Link>
            ))}
            <span className="vl-sep hide-mobile">·</span>
            <a href={SIGN_IN_URL} className="vl-cta">Sign in</a>
            <a href="mailto:henrik@hallengrens.com?subject=Vuelette%20%E2%80%93%20Request%20access" className="vl-cta vl-cta-primary">
              Request access
            </a>
          </div>
        </nav>
      </div>

      <main>{children}</main>

      <footer className="vl-footer">
        <div className="vl-footer-inner">
          <div>
            <div className="vl-brand-small-wrap">
              <Logo size="sm" />
            </div>
            <p className="vl-footer-tagline">Quietly made in Barcelona.</p>
          </div>
          <div className="vl-footer-links">
            <Link to="/">Hub</Link>
            <Link to="/for-models">Models</Link>
            <Link to="/for-photographers">Photographers</Link>
            <Link to="/for-duos">Duos</Link>
            <a href={SIGN_IN_URL}>Sign in</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
